/**
 * Единый источник констант приложения.
 * Соответствует значениям на бэкенде (Django/DRF).
 */

// Роли пользователей (user_type)
export const USER_ROLES = {
    ADMIN: 'admin',
    ROOT: 'root',
    MENTOR: 'teacher',
    STUDENT: 'student',
    ORGANIZATION: 'organization',
    USER: 'user', // Базовая роль
};
